import http from 'plugins/axios';

export default {
  reqList(data) {
    return http.get({
      url: `/la/admin/balance/bill/getInternalTransferRecordList`,
      data: { ...data, transferType: 1 }
    });
  },
  transfer({ tenantId, coin, amount }) {
    return http.post({
      url: `/la/admin/public/transfer?tenantId=${tenantId}&coin=${coin}&amount=${amount}`
    });
  },
  mockTransfer({ tenantId, userId, coin, amount, type }) {
    return http.post({
      url: `/la/admin/public/mock/transfer?tenantId=${tenantId}&userId=${userId}&coin=${coin}&amount=${amount}&type=${type}`
    });
  },
  getCoinTypes() {
    return http.get({
      url: '/la/admin/coin/allDisplay'
    });
  }
};
